<template>
  <div
    v-if="show"
    class="card speed_test"
  >
    <div class="speed_test__header">

      <h4 class="title" v-if="test_result.id">
        <span>{{ 'Test #'+test_result.id }}</span>
        <span>{{ get_date(test_result.ts) }}</span>
      </h4>
      <p class="duration" v-if="test_result.id">
        {{ translate('speed.duration') }}: {{test_result.duration}}
      </p>

      <h4 class="title" v-else>
        {{ translate('speed_test') }}
      </h4>


    </div>
    <div class="speed_test__content">
      <form v-if="!begin_test" autocomplete="off" class="speed_test__form" >
        <div class="auto-test" v-if="enable_test && allow_autotest">
          <div class="row">
            <div class="col-md-6">
              <div class="filter checkbox">
                <div class="info">
                  {{ translate('speed.auto_selection') }}
                </div>
                <label class="switch" @click.prevent="auto_test = !auto_test" >
                  <input type="checkbox" v-model="auto_test" />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>

            <div class="col-md-6">
              <div class="sim-cards">
                <label> {{ translate('speed.count_sim_card') }} </label>
                <tree-select
                    v-model="sim_count"
                    :options="simcards_list"
                    :hide-selected="true"
                    :multiple="false"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="options">
          <div class="interfaces" v-if="$store.getters.getPermissions.permissionGod === true">
            <label> {{ translate('speed.interfaces') }} </label>
            <tree-select
                v-model="options.ifaces"
                :options="sim_list"
                :searchable="false"
                :show-labels="false"
                :close-on-select="true"
                :clear-on-select="false"
                :hide-selected="true"
                :multiple="true"
                :disabled="auto_test"
            />
          </div>

          <div class="params" :class="{mb :$store.getters.getPermissions.permissionGod !== true}">
            <label> {{ translate('speed.params') }} </label>
            <tree-select
                v-model="options.mode"
                :options="params_list"
                :searchable="false"
                :show-labels="false"
                :close-on-select="true"
                :clear-on-select="false"
                :hide-selected="true"
                :multiple="true"
            />
          </div>

          <div class="speed_test__form-row" v-if="$store.getters.getPermissions.permissionGod === true">
            <div class="speed_test__form-row__input">
              <fg-input
                  v-model="options.threads"
                  type="number"
                  :label="translate('speed.threads')"
                  :placeholder="translate('speed.threads')"
              />
            </div>
            <div class="speed_test__form-row__input">
              <fg-input
                  v-model="options.duration"
                  type="number"
                  :label="translate('speed.duration')"
                  :placeholder="translate('speed.duration')"
              />
            </div>

            <div class="speed_test__form-row__input params">
              <label> {{ translate('speed.server') }} </label>
              <tree-select
                  :options="iperf_servers"
                  v-model="options.server"
                  placeholder="Команда"
                  :clearable="false"
                  :multiple="false"
                  :placeholder="translate('speed.server')"
                  :max-height="100"
              />
            </div>

          </div>
          <div class="speed_test__waiting_time" v-if="!auto_test">
            <label>{{ translate('speed.max_result_waiting_time') }}: {{ estimated_waiting_time }}</label>
          </div>
        </div>
      </form>

      <div v-else-if="combination_test_id !== null">
        <div class="content text-center title">
          Тестирование комбинаций симкарт запланировано. Результаты можно посмотреть во вкладке Тестирование / SelfTest
        </div>
      </div>

      <div v-else-if="begin_test" class="speed_test__result">
        <template v-if="now_speed !== null">
          <SpeedTest
              :speed="now_speed"
              :iface="iface_now"
              :mode="mode_now"
              class="SpeedGauge"
          />
        </template>
        <template v-else>
          <scale-loader v-if="loading" />
        </template>

        <div v-if="loading" class="speed_test__waiting_time">
          <label>{{ translate('speed.result_waiting_time') }}: {{ time_conversion(test_duration) }}</label>
          <label v-if="$store.getters.WsGetStatus">{{ translate(selftest_status_text_variable) }}</label>
        </div>

        <div v-else class="response_table4 text-center">
          <div v-if="error" class="content text-center title">
            {{ translate('self_tests.test_error') }}
          </div>

          <table v-else>
            <thead>
              <tr>
                <th
                  rowspan="1"
                  class="traffic_block"
                >
                  {{ translate('parameters') }} / {{ translate('self_tests.ifaces') }}
                </th>
                <th
                  v-for="(item,key) in th"
                  :key="key"
                  class="traffic_block"
                >
                  {{ item.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item2,key2) in tr"
                :key="key2"
              >
                <td class="tdFont traffic_block">
                  {{ translate("self_tests." + item2.name2) }}
                </td>
                <td
                  v-for="(val,dkey) in ifaces"
                  :key="dkey"
                >
                  {{ result_data[val][item2.name2][0] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="speed_test__button">
        <button
          v-if="!begin_test"
          type="submit"
          class="btn btn-info btn-fill btn-wd"
          :disabled="
            options.ifaces.length < 1 ||
              options.mode.length < 1 ||
              +options.duration < 1 ||
              +options.threads < 1 ||
              options.server === ''
          "
          @click.prevent="start_test"
        >
          {{ translate('speed.start_test') }}
        </button>

        <button
          v-if="begin_test && loading && check_version && combination_test_id === null"
          class="btn btn-info btn-fill btn-wd"
          @click="stop_selftest"
        >
          {{ translate('self_tests.stop_selftest') }}
        </button>

        <button
            class="btn btn-danger btn-fill btn-wd"
            @click.prevent="cancel"
        >
          {{ translate('close_modal') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>

import SpeedGauge from "components/UIComponents/Charts/SpeedGauge.vue";
import SpeedTest from "components/UIComponents/SpeedTest/Index.vue";

export default {
  name: "DeviceSpeedTest",
  components: {
    SpeedGauge,
    SpeedTest
  },
  props: [
    "fid",
    "sim_list",
    "version",
    "iperf_servers",
    "duration",
    "threads",
    "enable_test"
  ],

  data () {
    return {
      selftestID: null,
      begin_test: false,
      loading: false,
      now_speed: null,
      iface_now: null,
      mode_now: null,
      show: true,
      error: false,
      options: {
        ifaces: [],
        mode: ['iperf_down','iperf_up'],
        threads: null,
        duration: null,
        server: null
      },
      th: [],
      tr: [],
      ifaces: [],
      result_data: [],
      selftest_status_text_variable: 'speed.status_waiting_to_response_from_modem',
      test_duration: '',
      interval: 0,
      auto_test: false,
      sim_count: null,
      combination_test_id: null,

      test_result:{},
    }
  },

  computed:{
    allow_autotest(){
      return this.sim_list.filter(item => String(item.id).includes('usb_')).length > 2;
    },
    simcards_list(){
      return [
        { id: 2, label: "2" },
        { id: 3, label: "3" },
        { id: 4, label: "4" },
      ]
    },
    params_list(){
      let params = [
        {'label':'download', 'id':'iperf_down'},
        {'label':'upload', 'id':'iperf_up'}
      ]
      if (this.$store.getters.getPermissions.runDeviceSelftestPing === true){
        params.push({'label':'ping ', 'id':'ping'})
      }
      return params
    },
    estimated_waiting_time(){
      let duration = this.options.duration
      let iperf = this.options.mode
      let ifaces = this.options.ifaces
      let sum  = duration * iperf.length * ifaces.length * 1.2 + 15
      if (iperf.indexOf('ping') >= 0){
        sum += 5 * ifaces.length
      }
      return this.time_conversion(sum)
    },
    check_version(){
      if (typeof(this.version) !== "string") {
        return false
      }
      let clear_version = this.version.split('-')
      let version = '2.1.1'
      return this.version_compare(clear_version[0], version) >= 0
    },
  },

  watch:{
    auto_test(new_val, old_val){
      if (new_val === true) this.options.ifaces = ["stcp"]
    }
  },

  mounted () {
    this.iperf_servers.length > 0 ? this.options.server = this.iperf_servers[0].id : ""
    this.threads ? this.options.threads = this.threads : ""
    this.duration ? this.options.duration = this.duration : ""
    this.sim_list.length > 0 ? this.options.ifaces = [this.sim_list[0].id] : []

    this.checkIsselftestrunning()
  },
  deactivated(){
    clearInterval(this.interval)
  },
  destroyed() {
    if(this.$store.getters.WsGetStatus && this.selftestID){
      this.$store.dispatch("WS_Unsubscribe",`selftest.${this.selftestID}`)
    }
  },

  methods: {
    get_result(){
      this.$http.v1.getDeviceTestSelfTestsResult( {selftest_id: this.selftestID}, (response) => {
        this.test_result = {...response.data, id: this.selftestID}
        this.selftestID = null
      })
    },
    stop_selftest(){
      this.$http.v1.stopSelfTest(this.fid,() => {
        this.global_notify('info', 'Stoping Test')
      })
    },
    check_ip(){
      let arrIp = this.options.server.split(".");
      if (arrIp.length !== 4) {
        this.global_notify('danger', 'Invalid IP')
        this.options.server = ''
        return false
      }
      for (let oct of arrIp) {
        if ( isNaN(oct) || Number(oct) < 0 || Number(oct) > 255){
          this.global_notify('danger', 'Invalid IP')
          this.options.server = ''
          return false
        }
      }
      return true
    },
    countdown(){
      if (this.test_duration > 0) {
        this.test_duration -= 1
      }else{
        this.test_duration = 0
      }
    },
    time_conversion(time){
      let hours = Math.round(Math.floor(time / 60 / 60));
      let minutes = Math.round(Math.floor(time / 60) - (hours * 60));
      let seconds = Math.round(time % 60);
      if (hours < 1) {
        return ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
      }
      return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
    },
    cancel () {
      this.begin_test = false
      this.$emit('close')
      if(this.$store.getters.WsGetStatus && this.selftestID){
        this.$store.dispatch("WS_Unsubscribe",`selftest.${this.selftestID}`)
      } else {
        clearInterval(this.interval)
      }
      this.selftestID = null
      clearInterval(this.wait_interval)
    },

    checkIsselftestrunning () {
      this.$http.v1.statusDeviceTestSelfTest(this.fid, {dev_id: this.fid},(response) => {

        if (response.data.selftest_id) {
          this.begin_test = true
          this.loading = true
          let selfTestId = response.data.selftest_id

          let time = Math.floor(Date.now()/1000);
          this.test_duration = response.data.test_duration - (time - response.data.start_ts)
          this.wait_interval = setInterval(() => {
            this.countdown()
          }, this.$store.getters.getCountdown)
          this.selftestID = selfTestId
          if(this.$store.getters.WsGetStatus){
            let topic = `selftest.${selfTestId}`
            this.WSSelftestListenerHandler({data: JSON.stringify({ action: topic, data: { status: response.data.status }})})
            this.$store.dispatch("WS_Subscribe",{ topic: topic, func: this.WSSelftestListenerHandler })
          } else {
            this.interval = setInterval(() => {
              this.selftest(selfTestId)
            }, this.$store.getters.getDeviceSelftestResult)
          }
        }else{
          this.begin_test = false
          this.loading = false
        }
      })
    },
    start_test(){
      if (!this.check_ip()) return false

      let options = {...this.options}
      options.duration = Number(this.options.duration)
      options.threads = Number(this.options.threads)
      options.server = this.options.server.trim()

      let data = {
        comm: "selftest_init",
        params: {...options}
      }

      if (this.auto_test) {
        data.enable_test = this.auto_test
        data.sim_count = this.sim_count
      }

      this.loading = true
      this.begin_test = true

      this.$http.v1.initDeviceTestSelfTest(this.fid, data, (response) => {
        this.combination_test_id = response.data.combination_test_id || null
        let selfTestId = response.data.selftest_id

        this.test_duration = response.data.test_duration
        this.wait_interval = setInterval(() => {
          this.countdown()
        }, this.$store.getters.getCountdown)
        this.selftestID = selfTestId
        if(this.$store.getters.WsGetStatus){
          let topic = `selftest.${selfTestId}`
          this.$store.dispatch("WS_Subscribe",{ topic: topic, func: this.WSSelftestListenerHandler })
        } else {
          this.interval = setInterval(() => {
            this.selftest(selfTestId)
          }, this.$store.getters.getDeviceSelftestResult)
        }
      })
    },
    WSSelftestListenerHandler(cmd){
      try {
        if(cmd.data.type === 'result'){
          this.parse_selftest_data(cmd.data.data)
          if(this.$store.getters.WsGetStatus){
            this.$store.getters.WsGetConnection.send(JSON.stringify({
              action:"UNSUBSCRIBE",
              auth: this.$store.getters.WsGetAuth,
              topic: cmd.action
            }))
          }
          return
        }
        if(cmd.data.status){
          /**
           * Блок обработки состояний задачи
           */
          let task_data = cmd.data
          switch (task_data.status) {
            case 1:
              this.selftest_status_text_variable = "speed.status_accepted_from_device"
              break;
            case 2:
              this.selftest_status_text_variable = "speed.status_test_running_device"
              break;
            case 3:
              // Ошибка отправки
              break;
            case 4:
              this.selftest_status_text_variable = "speed.status_canceled_by_device"
              break;
            case 5:
              this.selftest_status_text_variable = "speed.status_error_complete"
              break;
            case 6:
              this.selftest_status_text_variable = "speed.status_success_complete"
              break;
          }
        } else {
          if(cmd?.data?.data){
            for (const mode in cmd?.data?.data) {
              if(mode !== 'done'){
                for (const iface in cmd?.data?.data[mode]) {
                  if(cmd?.data?.data[mode][iface].current) {
                    this.iface_now = iface
                    this.mode_now = mode
                    this.now_speed = cmd?.data?.data[mode][iface].current
                  }
                }
              }
            }
          }
          // this.now_speed = cmd.data.data[cmd.data.data.length - 1]
          /**
           * Блок обработки промежуточных данных
           */
          if(cmd.data?.data?.done){
            this.selftest_status_text_variable = "speed.status_success_complete"
          } else {
            this.selftest_status_text_variable = "speed.status_test_running_device"
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    parse_selftest_data(data){
      this.get_result()

      this.loading = false
      this.result_data = data
      let th = []
      let tr = []
      let name_iface = Object.keys(data)
      for (let i in name_iface) {
        th.push({name: name_iface[i]})
      }
      this.ifaces = name_iface
      this.th = th

      let parameters = Object.keys(data[name_iface[0]])
      for (let i in parameters) {
        tr.push({name2: parameters[i]})
      }
      this.iface_now = null
      this.mode_now = null
      this.now_speed = null
      this.parameters = parameters
      this.tr = tr
    },
    selftest(selfTestId){
      this.$http.v1.getDeviceTestSelfTestsResult({selftest_id: selfTestId}, (response) => {
        if (response.data.state === 0) {
          console.log("Queue")
        } else if (response.data.state === 1) {
          console.log("Sent to device")
        } else if (response.data.state === 2) {
          console.log("Performed")
        } else if (response.data.state === 5) {
          this.loading = false
          this.error = true
          clearInterval(this.interval)

        } else if (response.data.state === 6) {
          clearInterval(this.interval)
          this.parse_selftest_data(response.data.result)
        }
      })
    }
  }
}

</script>

<style lang='scss' scoped>
  .marginButton {
    margin: 5px;
  }
  .v-spinner {
    margin-bottom: 10px;
  }
  .tdFont {
    font-weight: bold;
  }
  .response_table4{
    height: auto;
  }
  .SpeedGauge{
    width: 100%;
    //height: 500px !important;
    //margin: -140px auto 0;
    //overflow: hidden
  }
  .speed_test{
    &__header{
      padding: 20px 10px 10px;
      .title{
        font-size: 22px;
        font-weight: 600;
        text-align: center;
        margin-top: 10px;
        text-transform: uppercase;
        margin-bottom: 5px;
        span{
          display: block;
        }
      }
      .duration{
        text-align: center;
        margin-bottom: 0;
      }
    }
    &__content{
      padding: 10px;
      .params{
        &.mb{
          margin-bottom: 50px;
        }
      }
    }
    &__form{
      &-row{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        &__input{
          width: 32%;
          .vue-treeselect{
            margin-bottom: 0;
          }
          .form-group{
            margin-bottom: 0;
          }
        }
      }
    }

    &__result{
      margin-bottom: 20px;
      table{
        display: table;
        height: auto;
        margin: auto;
      }
    }
    &__button{
      display: flex;
      justify-content: center;
      align-items: center;
      .btn{
        margin: 0 5px;
      }
    }
    &__waiting_time{
      label{
        text-align: center;
      }
    }
  }
  .auto-test{
    margin-bottom: 10px;
  }
  @media (max-width:600px) {
    .speed_test{
      &__form{
        &-row{
          flex-direction: column;
          &__input{
            width: 100%;
          }
        }
      }
    }
  }

</style>
